// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__yhSDU","header":"styles_header__fLjaz","searchBox":"styles_searchBox__hm2c3","candidateTable":"styles_candidateTable__WIll6"};